import { useState } from 'react';
import { SpinLoading } from 'antd-mobile';
import noOrder from '@/assets/img/no-order.png';
import addressEmpty from '@/assets/img/address-empty.png';
import noCoupon from '@/assets/img/no_coupon_icon.png';
import courseEmpty from '@/assets/img/empty-course.png';
import { useMount } from 'ahooks';
import HeadOpacityScrollContainer from '@/components/HeadOpacityScrollContainer';

export enum EMPTY_TYPE {
  ORDER = 'order',
  ADDRESS = 'address',
  ERROR = 'error',
  COUPON = 'coupon',
  COURSE = 'course',
  COURSE_DOWN = 'course_down',
}

const EMPTY_DATA = {
  [EMPTY_TYPE.ORDER]: {
    icon: noOrder,
    text: '暂无可查询的订单',
  },
  [EMPTY_TYPE.ADDRESS]: {
    icon: addressEmpty,
    text: '暂无收货地址哦',
  },
  [EMPTY_TYPE.ERROR]: {
    icon: '',
    text: '当前网络不可用，请检查网络设置',
  },
  [EMPTY_TYPE.COUPON]: {
    icon: noCoupon,
    text: '你来晚啦，空空如也',
  },
  [EMPTY_TYPE.COURSE]: {
    icon: courseEmpty,
    text: (
      <>
        <div>课程已下架，请联系辅导老师获取</div>
        <div>最新课程</div>
      </>
    ),
  },
  [EMPTY_TYPE.COURSE_DOWN]: {
    icon: courseEmpty,
    text: (
      <>
        <div>课程不存在，请联系辅导老师获取</div>
        <div>最新课程</div>
      </>
    ),
  },
};

interface LoadDataContainerProps<T> {
  children: React.ReactNode;
  onFetch: () => Promise<T>;
  onLoadSuccess?: (res: T) => void;
  onLoadError?: (err: Error) => void;
}

export default function LoadDataContainer<T>({
  children,
  onFetch,
  onLoadSuccess = () => {},
  onLoadError = () => {},
}: LoadDataContainerProps<T>) {
  const [loading, setLoading] = useState(true);
  const [emptyType, setEmptyType] = useState<EMPTY_TYPE | null>(null);
  const [headerData, setHeaderData] = useState<any>({
    title: '',
    show: false,
  });

  useMount(() => {
    onFetch()
      .then((res) => {
        setLoading(false);
        onLoadSuccess(res);
        if ((res as any)?.type && (res as any)?.data?.length === 0) {
          setEmptyType((res as any).type);
          setHeaderData((res as any).headerData || { title: '', show: false });
        }
      })
      .catch((err) => {
        setLoading(false);
        onLoadError(err);
      });
  });

  return (
    <>
      {loading ? (
        <div className="flex justify-center items-center h-screen w-screen">
          <SpinLoading color="primary" />
        </div>
      ) : emptyType ? (
        <HeadOpacityScrollContainer hide={!headerData.show} title={headerData.title}>
          <div className="mt-219px flex flex-col items-center">
            <img
              src={EMPTY_DATA[emptyType].icon}
              alt="empty"
              width="160"
              height="128"
              className="w-160px h-auto mx-auto"
            />
            <div className="text-14px color-#08021E text-center">{EMPTY_DATA[emptyType].text}</div>
          </div>
        </HeadOpacityScrollContainer>
      ) : (
        children
      )}
    </>
  );
}
